import "./index.css";
import { useRequest } from "ahooks";
import React, { useState } from "react";
import { Empty, Spin, Form } from "antd";
import { request } from "../../../request";
import { PersonalSite } from "../components/WebsitePreview";

interface TypeWorkspaceProps {
  loading?: boolean;
  /**
   * Personal site 是否还未初始化（跟当前会话组织走）
   */
  isUnInit: boolean;
  /**
   * 组织列表尚未返回 — Bluerate 预览先转圈，避免闪错空态
   */
  blueratePreviewLoading?: boolean;
  /**
   * Bluerate 预览是否可用（跟 primary org 走）
   */
  blueratePreviewReady?: boolean;
  /**
   * Bluerate 预览不可用时的说明（需点明组织 + 未初始化 / 审核中）
   */
  blueratePreviewDescription?: React.ReactNode;
  /**
   * @param blueRateURL bluetate 生成的地址
   */
  blueRateURL?: string;
  children?: React.ReactNode;
}

const ITEMS_IFRAME = ["Bluerate", "Personal site"];
const PERSONAL_SITE_PREVIEW_EMPTY_DESCRIPTION =
  "Once you click 'Complete setup & publish', you can preview the page.";

/**
 * @name Workspace 右侧集成 “Bluerate” 、 “Personal site” 预览，children（左侧）可继续写业务
 */
const Layout: React.FC<TypeWorkspaceProps> = ({
  loading,
  children,
  isUnInit,
  blueratePreviewLoading,
  blueratePreviewReady,
  blueratePreviewDescription,
  blueRateURL,
}) => {
  const [key, setKey] = useState(ITEMS_IFRAME[0]);

  const { data } = useRequest(() => request("/los/getappurl"));
  const showBlueratePreview =
    blueratePreviewReady ?? !isUnInit;

  return (
    <div className="layout-website-edit">
      <div className="layout-website-edit-operate">
        {loading ? <Spin spinning /> : null}
        {children}
      </div>
      <div className="layout-website-edit-iframe">
        <nav>
          <h5>Preview</h5>
          <ul>
            {ITEMS_IFRAME.map((k) => (
              <li
                key={k}
                onClick={() => setKey(k)}
                className={
                  k === key ? "layout-website-edit-selected" : undefined
                }
              >
                {k}
              </li>
            ))}
          </ul>
        </nav>
        <div className="layout-website-edit-iframe-ctx">
          {key === "Bluerate" ? (
            blueratePreviewLoading ? (
              <div className="layout-website-edit-iframe-loading">
                <Spin />
              </div>
            ) : showBlueratePreview ? (
              <iframe key={blueRateURL} src={blueRateURL} />
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  blueratePreviewDescription ||
                  PERSONAL_SITE_PREVIEW_EMPTY_DESCRIPTION
                }
              />
            )
          ) : isUnInit ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={PERSONAL_SITE_PREVIEW_EMPTY_DESCRIPTION}
            />
          ) : (
            <Form.Item shouldUpdate noStyle>
              {(form) => (
                <PersonalSite
                  appUrl={data?.appUrl}
                  data={form.getFieldsValue()}
                />
              )}
            </Form.Item>
          )}
        </div>
      </div>
    </div>
  );
};

export default Layout;
